<template>
  <div class="file-docicon" :class="fileClass(name)">
    <span class="sheet"></span>
    <span class="label">{{ fileLabel(name) }}</span>
  </div>
</template>

<script setup>
import { fileClass, fileLabel } from "../store";

defineProps({
  name: { type: String, required: true },
});
</script>

<style scoped>
.file-docicon {
  position: relative;
  width: 30px;
  height: 36px;
}
.file-docicon .sheet {
  position: absolute;
  inset: 0;
  border: 1px solid #dfe4eb;
  border-radius: 3px;
  background: #f3f5f8;
  overflow: hidden;
}
.file-docicon .sheet:before {
  content: "";
  position: absolute;
  right: -1px;
  top: -1px;
  border-style: solid;
  border-width: 0 0 12px 12px;
  border-color: transparent transparent #fff transparent;
  z-index: 2;
}
.file-docicon .sheet:after {
  content: "";
  position: absolute;
  right: -1px;
  top: -1px;
  border-style: solid;
  border-width: 0 0 13px 13px;
  border-color: transparent transparent #d7dde7 transparent;
}
.file-docicon .label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  text-align: center;
  font-size: 8.5px;
  font-weight: 800;
  line-height: 1;
}
.file-docicon.word .label {
  color: #1e7cff;
}
.file-docicon.pdf .label {
  color: #eb4b4b;
}
.file-docicon.excel .label {
  color: #16a36a;
}
.file-docicon.image .label {
  color: #7b4ce2;
}
.file-docicon.archive .label {
  color: #e8960c;
}
</style>
